import script from "./EventDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./EventDetail.vue?vue&type=script&setup=true&lang=js"

import "./EventDetail.vue?vue&type=style&index=0&id=58572c39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58572c39"]])

export default __exports__